
import { useEffect, useState } from "react";
import queryString from "query-string";
import { findUniquesLineTypes, ImportDataType, processParsedJSONProjectInformation, processParsedJSONToShapes } from "./importGeometricShape";
import { useAppDispatch } from "../../store/hooks";
import { init } from "../../store/model";
import { setLineTypes } from "../../store/tool";
import  LoaderIcon  from "../loaderIcon";
import { setLoading } from "../../store/interaction";

const FetchData = () => {
    const dispatch = useAppDispatch()
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    useEffect(() => {
        //Test Link from personal github, from public github api fetch
        //http://localhost:3000/?linkFrom=https%3A%2F%2Fapi.github.com%2Frepos%2FGazsoo%2FundoExperiment%2Fcontents%2Fpublic%2FBuildingDrawing.json%3Fref%3Dexperiment0
        const parsed = queryString.parse(window.location.search);
        const URIFrom = parsed.linkFrom;
        const fileImportURI = Array.isArray(URIFrom) ? "" : URIFrom

        const fetchData = async () => {
            let errorText = null;
            try {
                const response = await fetch(fileImportURI ?? "");
                if (!response.ok) {
                    console.log(response);
                    throw new Error('Network response was not ok');
                }

                const resultString = await response.json();
                const result: ImportDataType[] = JSON.parse(atob(resultString?.content))
                console.log(`Data red from link ${fileImportURI}`, result);

                const uniqueLineTypes = findUniquesLineTypes(result);
                console.log(uniqueLineTypes, "lineTypes");
                dispatch(setLineTypes(uniqueLineTypes));

                // const uniqueLayers = findUniquesLayers(result)
                // console.log(uniqueLayers, "layer types");
                // dispatch(changeLayerList(uniqueLayers));

                const shapes = processParsedJSONToShapes(result, uniqueLineTypes);
                const projectInfomation: any = processParsedJSONProjectInformation(result);
                const importModel = { shapes: shapes, projectInformation: projectInfomation };
                dispatch(init({ model: importModel }))
                dispatch(setLoading(false))
            }
            catch (error) {
                errorText = error instanceof Error ? error.message : 'Unknown error'
                setErrorMessage(errorText);
            }
        };

        if (fileImportURI) {
            fetchData();
        } else {
            dispatch(setLoading(false))
        }
    }, [dispatch]);

    if (errorMessage) return <p style={{ color: 'red' }}>Error: {errorMessage} { }</p>;
    return (
        <LoaderIcon>
            <div>{errorMessage}</div>
            {errorMessage && <button onClick={() => dispatch(setLoading(false))}>OK</button>}
        </LoaderIcon>
        );
}

export default FetchData;



